import React from 'react';
import { Tooltip } from '@material-ui/core';
import PlayIcon from '../../assets/play_btn.svg';
import EditIcon from '../../assets/edit_icn.svg';
import RemoveIcon from '../../assets/Delete.png';
import './PlaylistManagement.scss';

const icons = {
  listen: <img src={PlayIcon} alt="" />,
  copy: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M4 5h9M4 9h9M4 13h6M4 17h6" />
    <path d="M16 7v11m0 0-3-3m3 3 3-3" />
  </svg>,
  customers: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="9" cy="8" r="3" /><path d="M3.5 19v-1.5a5.5 5.5 0 0 1 11 0V19H3.5Z" />
    <path d="M16.5 5.5a3 3 0 0 1 0 5.5M17 14a4.5 4.5 0 0 1 3.5 4.5V19h-3" />
  </svg>,
  edit: <img src={EditIcon} alt="" />,
  remove: <img src={RemoveIcon} alt="" />,
  schedule: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" /><path d="M7 3v4M17 3v4M3 10h18M8 15h4" />
  </svg>,
};

export default function PlaylistActionIcon({ kind, label, onClick, disabled = false, active = false }) {
  return <Tooltip title={label} arrow>
    <span className="playlist-action-trigger">
      <button
        type="button"
        className={`playlist-action-icon${active ? ' playlist-action-icon-active' : ''}`}
        aria-label={label}
        disabled={disabled}
        onClick={onClick}
      >
        {icons[kind]}
      </button>
    </span>
  </Tooltip>;
}
